import { H3 } from '@repo/ui-kit/components/core/Typography';
import { themeStyle } from '@repo/ui-kit/themeStyle';
import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

const HEADER_HEIGHT = 72;

export const Title = styled(H3)``;

export const SearchPortalWrapper = styled.div`
  width: 100%;
`;

export const DesktopHeaderSearchWrapper = styled.div`
  width: 330px;
`;

export const MobileTitle = styled.div<{ hasPadding: boolean }>`
  ${({ hasPadding }) =>
    hasPadding
      ? `
    padding: 24px 24px 0;
  `
      : `
    margin-bottom: 20px;
  `}
`;

export const HeaderWrapper = styled(FlexRow).attrs({
  className: 'header-wrapper',
})`
  width: 100%;
  height: ${HEADER_HEIGHT}px;
  gap: ${themeStyle.spacing8};
  align-items: center;
  padding: 24px;

  > div {
    flex: 1;
  }
`;

export const MobileHeaderWrapper = styled(FlexRow)`
  width: 100%;
  height: ${HEADER_HEIGHT}px;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  position: relative;
`;

export const SearchContainer = styled(FlexRow)<{ isOpen: boolean }>`
  position: absolute;
  left: 57px;
  top: 0;
  right: 0;
  height: 100%;
  background: inherit;
  padding: 24px 24px 24px 0;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transform: translateX(${({ isOpen }) => (isOpen ? '0' : '-20px')});
  transition: all 0.2s ease-in-out;
  pointer-events: ${({ isOpen }) => (isOpen ? 'auto' : 'none')};
  z-index: 1;
  gap: ${themeStyle.spacing8};
  align-items: center;
`;

export const NotificationsTriggerButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
`;

export const NotificationsWrapper = styled.div`
  margin-right: ${themeStyle.spacing8};
`;

export const ProfileMenuWrapper = styled.div`
  margin-right: 16px;
`;

export const AvatarWrapper = styled.div`
  width: 40px;
  height: 40px;
`;

export const MenuToggle = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  outline: none;
`;
